import type { PeriodOverPeriodRawData } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/types";
import type { ColumnChartData } from "pro-features/components/Chart/src/types";
import {
    TRAFFIC_METRIC,
    PREVIOUS_PERIOD_TRAFFIC_METRIC,
    COLORS,
} from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/const";
import { getFlattenSelectedCategory } from "app/pages/industry-analysis/common/getSelectedCategory";
import { getFlattenedCategoriesData } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/utils/getFlattenedCategoriesData";
import { compareFunctionHof } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/utils/compareFunctionHof";
import { parse } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/utils/parse";
import { fixedSelectedIndustryPosition } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/utils/fixedSelectedIndustryPosition";

const { BLUE, ORANGE } = COLORS;

const applyDefaultColor = (series: ColumnChartData, color: string): ColumnChartData => {
    const { data = [] } = series[0];
    const displayData = data.map((columnChartDataItem) => ({ ...columnChartDataItem, color }));
    const displaySeries = [{ data: displayData }];
    return displaySeries;
};

const parseRawData = (rawData: PeriodOverPeriodRawData): ColumnChartData => {
    const categoriesData = rawData.CategoriesData;
    const flattenedCategory = getFlattenSelectedCategory();
    const flattenedCategoriesData = getFlattenedCategoriesData(categoriesData);
    const compareFunction = compareFunctionHof(flattenedCategory);
    const sortedFlattenedCategoriesData = fixedSelectedIndustryPosition(
        flattenedCategoriesData.sort(compareFunction),
        flattenedCategory,
    );
    const currentSeries = parse(sortedFlattenedCategoriesData, flattenedCategory, TRAFFIC_METRIC);
    const previousSeries = parse(sortedFlattenedCategoriesData, flattenedCategory, PREVIOUS_PERIOD_TRAFFIC_METRIC);
    const displayCurrentSeries = applyDefaultColor(currentSeries, BLUE);
    const displayPreviousSeries = applyDefaultColor(previousSeries, ORANGE);
    return [...displayPreviousSeries, ...displayCurrentSeries];
};

export const parseRawDataHof =
    () =>
    (rawData: PeriodOverPeriodRawData): ColumnChartData =>
        parseRawData(rawData);
